export const BREAKPOINTS = {
  small: 720,
  medium: 1024,
  large: 1708
}